var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-bottom"},[_vm._v("©版权所有:"+_vm._s(_vm.academyName)+" 成人高考考前辅导平台")])}
var staticRenderFns = []

export { render, staticRenderFns }